// import React, { AnchorHTMLAttributes } from "react";
// import NextLink from 'next/link'
// const MenuLink: React.FC<AnchorHTMLAttributes<HTMLAnchorElement>> = ({ href, ...otherProps }) => {
//   const isHttpLink = href?.startsWith("http");
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   const Tag: any = isHttpLink ? "a" : NextLink;
//   const props = isHttpLink ? { href } : { to: href };
//   return <Tag {...props} {...otherProps} />;
// };
// export default MenuLink;
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import styled from "styled-components";
import NextLink from "next/link";
var A = styled.a.withConfig({
    componentId: "sc-161e332-0"
})(_templateObject());
/**
 * temporary solution for migrating React Router to Next.js Link
 */ var MenuLink = /*#__PURE__*/ forwardRef(function(_param, ref) /*#__PURE__*/ {
    var to = _param.to, replace = _param.replace, children = _param.children, prefetch = _param.prefetch, props = _object_without_properties(_param, [
        "to",
        "replace",
        "children",
        "prefetch"
    ]);
    return _jsx(NextLink, {
        href: to,
        replace: replace,
        passHref: true,
        prefetch: prefetch,
        children: /*#__PURE__*/ _jsx(A, _object_spread_props(_object_spread({
            ref: ref
        }, props), {
            children: children
        }))
    });
});
export default MenuLink;
